export enum BulkUploadTaskStatus {
	STARTING = 'STARTING',
	IN_PROGRESS = 'IN_PROGRESS',
	FAILED = 'FAILED',
	COMPLETED = 'COMPLETED'
}
